import {
  Box,
  Checkbox,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import CustomDialog from "../../components/CustomDialog";
import ls from "local-storage";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import useLocale from "../../../hooks/useLocale";
import { useState } from "react";
import ViewMoreInfoDialog from "./ViewMoreInfoDialog";
import styled from "styled-components/";
import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import CustomEditor from "../../components/Editor";
import fileDownload from 'js-file-download';
import axios from "../../../utils/axios";
import Axios from "axios";

// import entypoAitApogrNayt from '../../../../public/static/docs/entypoAitApogrNayt.doc';

import {
  CHANGECOLOR,
  ISSUE_COPY_NAUTICAL,
  NEW_NAUTICAL_APPLICATION,
  STOLENORLOST,
} from "../../../constants";
import GovGrButton from "../../../components/GovGrButton";
import className from "classnames";
import {
  GOVGR_CARD,
  GOVGR_CARD__ACTION,
  GOVGR_CARD__BORDER,
  GOVGR_CARD__BORDER_GRAY,
  GOVGR_CARD__HEADING,
} from "../../../conf/styles/GovGrCard";

import { Appication_A_URL, Appication_B_URL, Appication_C_URL } from "../../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  header: {
    wordWrap: "overflow-wrap",
    overflowWrap: "break-word",
  },
}));

const StyledDialogContentText = styled(DialogContentText)`
  height: 50vh;
  overflow-y: auto;
  padding: 1rem;
`;

const StyledBox = styled(Box)`
  display: flex;
  margin-left: 1.5rem;
  flex-direction: column;
`;

const TypographyBoxWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

const DialogActionsWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PDBoxWrapper = styled(Box)`
  display: flex;
  /* flex-direction: column; */
  width: 100%;
`;

const StyledGrid = styled(Grid)`
  max-width: 100%;
`;
const HomepageApplicationCard = (props) => {
  const { t } = useLocale();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const classes = useStyles(props);

  const [editorState, setEditorState] = useState("");
  const [checkedInfo, setCheckedInfo] = useState(false);
  const [checkedCertify, setCheckedCertify] = useState(false);
  const [checkedBlueNautical, setCheckedBlueNautical] = useState(false);
  const [checkedRedNautical, setCheckedRedNautical] = useState(false);
  const [
    checkedNauticalIssueLostOrStolen,
    setCheckedNauticalIssueLostOrStolen,
  ] = useState(false);
  const [checkedNauticalIssueChangeColor, setCheckedNauticalIssueChangeColor] =
    useState(false);
  const [dialogActionsEnable, setDialogActionsEnable] = useState(false);
  let CardWrapperClass = className(
    GOVGR_CARD,
    GOVGR_CARD__BORDER,
    GOVGR_CARD__BORDER_GRAY,
    classes.root
  );
  let CardHeadingWrapperClass = className(GOVGR_CARD__HEADING, classes.header);
  let CardActionWrapperClass = className(GOVGR_CARD__ACTION);
  const history = useHistory();
  const [isViewMoreInfoDialogOpen, setIsViewMoreInfoDialogOpen] =
    useState(false);

  const handleExpandClick = () => {
    setIsViewMoreInfoDialogOpen(true);
  };

  const [downloading, setDownloading] = useState(false);

  const downloadFile = () => {
    const link = document.createElement('a');

    link.download = 'Example-PDF-File';
    let src = "/static/docs/entypoAitApogrNayt.doc"
    switch (props.applicationKindId) {
      case 16: {
        link.download = 'entypoAitApogrNayt';
        let src = "/static/docs/entypoAitApogrNayt.doc"
      } break;
      case 18: {

        link.download = 'entypoAitEpanNaytikou';
        let src = "/static/docs/entypoAitEpanNaytikou.doc"
      } break;
      case 23: {
        link.download = 'entypoEkdAntNayFyl';
        let src = "/static/docs/entypoEkdAntNayFyl.doc"
      } break;
    }
    link.href = src;
    link.click();
  }

  const handleDownloadApplicationClick = () => {
    // console.log(props.applicationKindId)
    // let url = "aaa";
    // let filename = "";
    // // url = 'https://example.com/file.txt';
    // filename = 'Application.doc';
    // console.log(process.env);
    // switch (props.applicationKindId) {
    //   case 16: {
    //     url = Appication_A_URL;

    //     filename = "Αίτηση έκδοσης Ναυτικού φυλλαδίου.doc";
    //   } break;
    //   case 18: {
    //     url = Appication_B_URL;

    //     filename = "Αίτηση επαναπογραφής ναυτικού.doc";

    //   } break;
    //   case 23: {
    //     url = Appication_C_URL;

    //     filename = "Αίτηση έκδοσης αντιγράφου ναυτικού φυλλαδίου.doc";
    //   } break;
    // }
    // console.log(url);
    downloadFile();

  };



  const handleNewApplication = (id, forMe) => {
    history.push(`/auth/login/${id}/${forMe}`);
  };

  useEffect(() => {
    setEditorState(() => {
      let contentBlock = null;
      if (props.details) {
        contentBlock = htmlToDraft(props.details);
      }
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        return newEditorState;
      }
    });
  }, [props.details]);

  // Check if the application is New Nautical and return true or false to hide the extra fields
  const checkNewNautical = () => {
    if (
      parseInt(props?.applicationKindId) === parseInt(NEW_NAUTICAL_APPLICATION)
    ) {
      return true;
    } else {
      return false;
    }
  };

  //Check if the application is Copy of Nautical and return true or false to hide the extra fields

  const checkCopyNauticalApplication = () => {
    if (parseInt(props?.applicationKindId) === parseInt(ISSUE_COPY_NAUTICAL)) {
      return true;
    } else {
      return false;
    }
  };

  const handleChangeInfo = () => {
    setCheckedInfo(!checkedInfo);
  };

  const handleChangeCertify = () => {
    setCheckedCertify((prevCheckedCertify) => !prevCheckedCertify);
  };
  

  const handleChangeBlueNauticalColor = () => {
    setCheckedBlueNautical(!checkedBlueNautical);
    if (checkedRedNautical === true) {
      setCheckedRedNautical(false);
    }
    ls.set("nauticalPdColor", "blue");
  };
  const handleChangeRedNauticalColor = () => {
    setCheckedRedNautical(!checkedRedNautical);
    if (checkedBlueNautical === true) {
      setCheckedBlueNautical(false);
    }
    ls.set("nauticalPdColor", "red");
  };

  const handleChangeLostOrStolenNauticalIssue = () => {
    setCheckedNauticalIssueLostOrStolen(!checkedNauticalIssueLostOrStolen);
    if (checkedNauticalIssueChangeColor === true) {
      setCheckedNauticalIssueChangeColor(false);
    }
    ls.set("copynauticalissue", `${STOLENORLOST}`);
  };
  const handleChangeColorNauticalIssue = () => {
    setCheckedNauticalIssueChangeColor(!checkedNauticalIssueChangeColor);
    if (checkedNauticalIssueLostOrStolen === true) {
      setCheckedNauticalIssueLostOrStolen(false);
    }
    ls.set("copynauticalissue", `${CHANGECOLOR}`);
  };

  const clearAllSelections = () => {
    setDialogActionsEnable(false);
    setCheckedNauticalIssueChangeColor(false);
    setCheckedNauticalIssueLostOrStolen(false);
    setCheckedRedNautical(false);
    setCheckedBlueNautical(false);
    setCheckedCertify(false);
  };

  useEffect(() => {
    if (
      checkCopyNauticalApplication() &&
      (checkedNauticalIssueLostOrStolen || checkedNauticalIssueChangeColor) &&
      checkedInfo && checkedCertify
    ) {
      setDialogActionsEnable(true);
    } else if (
      checkNewNautical() &&
      (checkedBlueNautical || checkedRedNautical) &&
      checkedInfo && checkedCertify
    ) {
      setDialogActionsEnable(true);
    } else if (
      checkedInfo && checkedCertify &&
      !(checkNewNautical() || checkCopyNauticalApplication())
    ) {
      setDialogActionsEnable(true); // Always explicitly set to true or false
    } else {
      setDialogActionsEnable(false);
    }
  }, [checkedBlueNautical, checkedRedNautical, checkedInfo, checkedNauticalIssueLostOrStolen, checkedNauticalIssueChangeColor, checkedCertify, checkCopyNauticalApplication, checkNewNautical]);
  

  return (
    <>
      <div className={CardWrapperClass}>
        <div role="heading" aria-level="2" className={CardHeadingWrapperClass}>
          {props.title}
        </div>
        <br></br>
        <div className={CardActionWrapperClass}>
          <GovGrButton
            buttonText={t("New application")}
            variant="primary"
            onClick={() => setIsModalOpen(true)}
            hasImage={true}
          />
        </div>
        <br></br>
        <GovGrButton
          variant="link"
          onClick={handleExpandClick}
          buttonText={t("More information")}
        />
        <br></br>
        <GovGrButton
          variant="link"
          onClick={handleDownloadApplicationClick}
          buttonText={t("Application form")}
        />
      </div>
      <CustomDialog
        open={isModalOpen}
        maxWidth="md"
        onClose={() => {
          setIsModalOpen(false);
          clearAllSelections();
        }}
      >
        <DialogTitle id="form-dialog-title">
          {t("Information about the application")}
        </DialogTitle>
        <StyledDialogContentText>
          <CustomEditor toolbarHidden readOnly editorState={editorState} />
        </StyledDialogContentText>
        <Grid container direction="column">
          <Grid item xs={9}>
            <StyledBox>
              <TypographyBoxWrapper>
                <Typography variant="h6">
                  {t("I have read the info about") + ` ${props.title}`}
                </Typography>
                <Checkbox checked={checkedInfo} onChange={handleChangeInfo} />
              </TypographyBoxWrapper>
              <TypographyBoxWrapper>
                <Typography variant="h6">
                  {t("I certify that i have been informed")}
                </Typography>
                <Checkbox checked={checkedCertify} onChange={handleChangeCertify} />
              </TypographyBoxWrapper>
              {checkNewNautical() && (
                <>
                  <PDBoxWrapper>
                    <TypographyBoxWrapper>
                      <Typography variant="h6">{t("Blue Nautical")}</Typography>
                      <Checkbox
                        checked={checkedBlueNautical}
                        onChange={handleChangeBlueNauticalColor}
                      // disabled={disableBlueCheckBox}
                      />
                    </TypographyBoxWrapper>
                    {checkedBlueNautical && (
                      <StyledBox>
                        <Typography>
                          {t("For high school graduates and higher level")}
                        </Typography>
                        <Typography>
                          {t(
                            "Holders of a degree or certificate of Rescue & Firefighting"
                          )}
                        </Typography>
                      </StyledBox>
                    )}
                  </PDBoxWrapper>
                  <PDBoxWrapper>
                    <TypographyBoxWrapper>
                      <Typography variant="h6">{t("Red Nautical")}</Typography>
                      <Checkbox
                        checked={checkedRedNautical}
                        onChange={handleChangeRedNauticalColor}
                      // disabled={disableRedCheckBox}
                      />
                    </TypographyBoxWrapper>
                    {checkedRedNautical && (
                      <StyledBox>
                        <Typography>
                          {t("For primary and higher level graduates")}
                        </Typography>
                        <Typography>
                          {t(
                            "Time limit for presenting a degree or certification of Rescue & Firefighting , 9 months from the issuance of the NF"
                          )}
                        </Typography>
                      </StyledBox>
                    )}
                  </PDBoxWrapper>
                </>
              )}
              {checkCopyNauticalApplication() && (
                <>
                  <PDBoxWrapper>
                    <TypographyBoxWrapper>
                      <Typography variant="h6">
                        {t("Nautical Issue Lost or Stolen")}
                      </Typography>
                      <Checkbox
                        checked={checkedNauticalIssueLostOrStolen}
                        onChange={handleChangeLostOrStolenNauticalIssue}
                      // disabled={disableBlueCheckBox}
                      />
                    </TypographyBoxWrapper>
                  </PDBoxWrapper>
                  <PDBoxWrapper>
                    <TypographyBoxWrapper>
                      <Typography variant="h6">
                        {t("Change Color of Nautical Issue")}
                      </Typography>
                      <Checkbox
                        checked={checkedNauticalIssueChangeColor}
                        onChange={handleChangeColorNauticalIssue}
                      // disabled={disableRedCheckBox}
                      />
                    </TypographyBoxWrapper>
                  </PDBoxWrapper>
                </>
              )}
            </StyledBox>
          </Grid>
          <StyledGrid item xs={3}>
            <DialogActionsWrapper>
              <Typography variant="h6" style={{ marginLeft: "1.5rem" }}>
                {t("Is the application for you or for another person?")}
              </Typography>

              <DialogActions>
                <Button
                  color="primary"
                  onClick={() =>
                    handleNewApplication(props.applicationKindId, 1)
                  }
                  disabled={!dialogActionsEnable ? true : false}
                >
                  {t("Myself")}
                </Button>
                <Button
                  color="primary"
                  onClick={() =>
                    handleNewApplication(props.applicationKindId, 0)
                  }
                  disabled={!dialogActionsEnable ? true : false}
                >
                  {t("Another person")}
                </Button>
              </DialogActions>
            </DialogActionsWrapper>
          </StyledGrid>
        </Grid>
      </CustomDialog>
      <ViewMoreInfoDialog
        open={isViewMoreInfoDialogOpen}
        close={() => setIsViewMoreInfoDialogOpen(false)}
        info={props.details}
      />
    </>
  );
};

export default HomepageApplicationCard;
